/**
 * AWS Amplify Configuration
 *
 * Configured with Cognito User Pool for authentication.
 * When running locally (npm start), we default to the dev environment.
 * Set REACT_APP_DEV_COGNITO_USER_POOL_ID and REACT_APP_DEV_COGNITO_CLIENT_ID
 * in .env.development.local from your dev stack:
 *   terraform output -raw cognito_user_pool_id
 *   terraform output -raw cognito_user_pool_client_id
 */

import { Amplify } from 'aws-amplify';
import type { ResourcesConfig } from 'aws-amplify';

const isDevelopment = process.env.NODE_ENV === 'development';

// In development, prefer dev env vars so local runs use dev Cognito
const cognitoUserPoolId =
  process.env.REACT_APP_COGNITO_USER_POOL_ID ||
  (isDevelopment && process.env.REACT_APP_DEV_COGNITO_USER_POOL_ID) ||
  'us-east-2_NeMq5uAeD';

const cognitoClientId =
  process.env.REACT_APP_COGNITO_CLIENT_ID ||
  (isDevelopment && process.env.REACT_APP_DEV_COGNITO_CLIENT_ID) ||
  '';

const awsRegion =
  process.env.REACT_APP_AWS_REGION ||
  'us-east-2';

// Validate required configuration
if (!cognitoUserPoolId || !cognitoClientId) {
  console.error('Missing Cognito configuration:', {
    userPoolId: cognitoUserPoolId || 'MISSING',
    clientId: cognitoClientId || 'MISSING',
    region: awsRegion,
  });
}

// For AWS Amplify v6, use ResourcesConfig structure
// v6 expects: Auth.Cognito.userPoolId, Auth.Cognito.userPoolClientId
const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: cognitoUserPoolId,
      userPoolClientId: cognitoClientId,
      loginWith: {
        email: true,
      },
    },
  },
};

// Only configure if we have the required values
if (cognitoUserPoolId && cognitoClientId) {
  try {
    Amplify.configure(amplifyConfig);
    console.log('Amplify configured successfully:', {
      userPoolId: cognitoUserPoolId,
      region: awsRegion,
      clientId: cognitoClientId,
      config: amplifyConfig,
    });
  } catch (error) {
    console.error('Error configuring Amplify:', error);
    console.error('Configuration attempted:', amplifyConfig);
  }
} else {
  console.error('Amplify not configured - missing required Cognito values:', {
    userPoolId: cognitoUserPoolId || 'MISSING',
    clientId: cognitoClientId || 'MISSING',
    region: awsRegion,
  });
}

export default amplifyConfig;

